import { defineMessages } from "react-intl";

import { node as albumin } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/albumin";
import { node as alkalinePhosphatase } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/alkalinePhosphatase";
import { node as bilirubinDirect } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/bilirubinDirect";
import { node as bilirubinTotal } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/bilirubinTotal";
import { node as calcium } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/calcium";
import { node as combinedKidneyPancreas } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/combinedKidneyPancreas";
import { node as creatinine } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/creatinine";
import { node as crp } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/crp";
import { node as eGfr } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/eGfr";
import { node as fastingGlucose } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/fastingGlucose";
import { node as ferritine } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/ferritine";
import { node as ggt } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/ggt";
import { node as got } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/got";
import { node as gpt } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/gpt";
import { node as haemoglobin } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/haemoglobin";
import { node as hgbA1C } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/hgbA1C";
import { node as hgbA1CCalculated } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/hgbA1CCalculated";
import { node as inr } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/inr";
import { node as iPth } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/iPth";
import { node as karbamid } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/karbamid";
import { node as ldlCholesterol } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/ldlCholesterol";
import { node as natrium } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/natrium";
import { node as otherLabProcedure } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/otherLabProcedure";
import { node as phosphate } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/phosphate";
import { node as potassium } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/potassium";
import { node as psa } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/psa";
import { node as restDiuresis } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/restDiuresis";
import { node as serumIron } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/serumIron";
import { node as stoolBlood } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/stoolBlood";
import { node as stoolculture } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/stoolculture";
import { node as t3 } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/t3";
import { node as t4 } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/t4";
import { node as thrombocyte } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/thrombocyte";
import { node as totalCholesterol } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/totalCholesterol";
import { node as totalIronBindingCapacity } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/totalIronBindingCapacity";
import { node as totalProtein } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/totalProtein";
import { node as totalUrineAnalysis } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/totalUrineAnalysis";
import { node as transferrinSaturation } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/transferrinSaturation";
import { node as triglyceride } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/triglyceride";
import { node as tsh } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/tsh";
import { node as urate } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/urate";
import { node as urineculture } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/urineculture";
import { node as urineProteinCreatinineRatio } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/urineProteinCreatinineRatio";
import { node as whiteBloodCellCount } from "src/modules/ktx/forms/transplantation-screening/lab-procedures/whiteBloodCellCount";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.lab_procedures",
		defaultMessage: "Laborvizsgálatok"
	}
});

export const node: ParentNode = {
	id: "ktx-lab-procedures",
	value: { type: "list", title: messages.title, columns: 2 },
	children: [
		whiteBloodCellCount,
		haemoglobin,
		thrombocyte,
		natrium,
		potassium,
		calcium,
		phosphate,
		creatinine,
		karbamid,
		eGfr,
		fastingGlucose,
		totalProtein,
		bilirubinDirect,
		bilirubinTotal,
		got,
		gpt,
		ggt,
		alkalinePhosphatase,
		inr,
		crp,
		totalCholesterol,
		ldlCholesterol,
		triglyceride,
		urate,
		tsh,
		hgbA1C,
		hgbA1CCalculated,
		serumIron,
		totalIronBindingCapacity,
		transferrinSaturation,
		ferritine,
		iPth,
		psa,
		totalUrineAnalysis,
		restDiuresis,
		urineculture,
		stoolBlood,
		combinedKidneyPancreas,
		otherLabProcedure,

		albumin,
		stoolculture,
		t3,
		t4,
		urineProteinCreatinineRatio
	]
};
